import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperOverviewCashPage } from './shopper-overview-cash';

@NgModule({
  declarations: [
    ShopperOverviewCashPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperOverviewCashPage),
    TranslateModule.forChild()
  ],
})
export class ShopperOverviewCashPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-overview-cash/shopper-overview-cash.module.ts